/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UtilHttpOkBody model module.
 * @module model/UtilHttpOkBody
 * @version 1.0
 */
class UtilHttpOkBody {
    /**
     * Constructs a new <code>UtilHttpOkBody</code>.
     * @alias module:model/UtilHttpOkBody
     */
    constructor() { 
        
        UtilHttpOkBody.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UtilHttpOkBody</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UtilHttpOkBody} obj Optional instance to populate.
     * @return {module:model/UtilHttpOkBody} The populated <code>UtilHttpOkBody</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UtilHttpOkBody();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} status
 */
UtilHttpOkBody.prototype['status'] = undefined;






export default UtilHttpOkBody;

